export default __webpack_public_path__ + "static/media/Pay-Per-Click-Header.dffecc6b.png";